<div
  id="documents-content"
  class="relative min-h-12"
  (dragenter)="onDragEnter($event)"
  (dragover)="onDragOver($event)"
  (dragleave)="onDragLeave($event)"
  (drop)="onDrop($event)"
>

  @if (documents.length > 0) {
    <span class="italic text-muted-color flex flex-row items-center gap-2">
      <mat-icon [size]="20">cloud_upload</mat-icon>
      {{ 'internal.document-viewer.dropText' | translate }}
    </span>
  }

  <div
    id="documents-list"
    class="flex flex-row gap-2 flex-wrap relative mt-1"
    [class.dragged]="isDragOver"
  >
    @for (f of documents; track f) {
    <div class="document p-1 rounded-sm bg-emphasis flex flex-row gap-2 items-center min-w-0 max-w-full">
      <mat-icon iconClass="min-w-6">{{fileIcon(f.mimeType)}}</mat-icon>
      <span class="text-ellipsis text-nowrap overflow-hidden">{{f.fileName}}</span>
      <div class="flex flex-row gap-1 items-center">
        @if (showView) {
        <p-button [rounded]="true" [text]="true" size="small" severity="contrast" (onClick)="downloadDoc(f.fileName, false)" [loading]="loading()">
          @if (!loading()) {<mat-icon>visibility</mat-icon>}
        </p-button>
        }
        @if (showDownload) {
        <p-button [rounded]="true" [text]="true" size="small" severity="contrast" (onClick)="downloadDoc(f.fileName, true)" [loading]="loading()">
          @if (!loading()) {<mat-icon>file_download</mat-icon>}
        </p-button>
        }
        @if (showDelete) {
        <p-button [rounded]="true" [text]="true" size="small" severity="danger" (onClick)="deleteFile(f.fileName)">
          <mat-icon>delete</mat-icon>
        </p-button>
        }
      </div>
    </div>
    }
  </div>

  @if (isDragOver) {
  <div class="document-overlay">
    <mat-icon [size]="24">cloud_upload</mat-icon>
    <div class="document-overlay-text">
      {{ 'internal.document-viewer.dropText' | translate }}
    </div>
  </div>
  } @else if (documents.length == 0) {
    <div class="document-overlay empty">
      <mat-icon [size]="24">cloud_upload</mat-icon>
      <div class="document-overlay-text">
        {{ 'internal.document-viewer.dropText' | translate }}
      </div>
    </div>
  }
</div>









<!-- <div id="documents-content">
  <input
    hidden
    type="file"
    accept=".jpg,.png,.jpeg,.pdf"
    #fileInput
    (change)="uploadFile($event.target)"
  />
  <div id="documents-list">
    @for (f of documents; track f) {
      <div class="document">
        <div class="document-embed">
          @if (f.mimeType == 'application/pdf') {
            <embed
              width="100"
              height="100"
              name="plugin"
              [src]="fileUrl(f.fileName) | useHttpImgSrc"
              type="application/pdf"
            />
          }
          @if (f.mimeType != 'application/pdf') {
            <img width="100" height="100" [src]="fileUrl(f.fileName) | useHttpImgSrc" />
          }
        </div>
        <div class="document-actions">
          <div class="flex flex-row justify-evenly">
            @if (showView) {
              <p-button [rounded]="true" [text]="true" (onClick)="downloadDoc(f.fileName, false)">
                <mat-icon color="white">visibility</mat-icon>
              </p-button>
            }
            @if (showDownload) {
              <p-button [rounded]="true" [text]="true" (onClick)="downloadDoc(f.fileName, true)">
                <mat-icon color="white">file_download</mat-icon>
              </p-button>
            }
          </div>
          @if (showDelete) {
            <div class="flex flex-row justify-evenly">
              <p-button
                [rounded]="true"
                [text]="true"
                severity="danger"
                (onClick)="deleteFile(f.fileName)"
              >
                <mat-icon color="white">delete</mat-icon>
              </p-button>
            </div>
          }
        </div>
      </div>
    }

    @if (showUpload) {
      <div id="documents-add" class="document" (click)="fileInput.click()">
        <mat-icon [size]="48">upload</mat-icon>
      </div>
    }
  </div>
</div>
 -->